export default {
  mounted(el, binding) {
    const options = {
      threshold: binding.value?.threshold || 0.1,
      rootMargin: binding.value?.rootMargin || '0px',
      duration: binding.value?.duration || '0.6s',
      delay: binding.value?.delay || '0s',
      easing: binding.value?.easing || 'ease-out',
    }

    // Set initial styles
    el.style.opacity = '0'
    el.style.transform = 'translateY(20px)'
    el.style.transition = `opacity ${options.duration} ${options.easing} ${options.delay}, transform ${options.duration} ${options.easing} ${options.delay}`

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1'
            entry.target.style.transform = 'translateY(0px)'
            //Optional: Stop observing after animation
            observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold: options.threshold,
        rootMargin: options.rootMargin,
      }
    )

    observer.observe(el)

    // Store observer for cleanup
    el._scrollAnimateObserver = observer
  },

  unmounted(el) {
    if (el._scrollAnimateObserver) {
      el._scrollAnimateObserver.disconnect()
    }
  },
}
